import React from 'react'

const SvgVolumeOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 16l4.537 3.934c.417.138.764.118 1.041-.058.278-.176.419-.476.422-.9l.004-13.679c.017-.576-.124-.953-.422-1.13-.298-.177-.645-.207-1.04-.09L6.003 8h-2c-1.333.006-2 .673-2 2 0 1.765-.004 3.434-.004 3.998 0 1.325.667 1.992 2 2.002H6zm.004-2l-2-.002V10h2c.151 0 1.485-1.007 4-3.02v10.24c-2.515-2.147-3.849-3.22-4-3.22zm11.394 5.797a1 1 0 001.4-.189c2.068-2.71 3.206-4.095 3.206-7.582 0-3.486-1.137-4.924-3.202-7.632a1 1 0 10-1.59 1.213c1.8 2.36 2.792 3.368 2.792 6.42 0 3.051-.992 4.005-2.795 6.37a.998.998 0 00.189 1.4zm-2.674-3.29c.44.336.816.326 1.402-.187 1.02-.895 1.878-2.532 1.878-4.292 0-1.76-.73-3.238-1.878-4.325-.345-.4-.96-.497-1.399-.162-.439.336-.546 1.095-.189 1.402 1.113.956 1.466 2.083 1.466 3.085 0 1.001-.319 2.001-1.468 3.08-.146.136-.205.393-.205.605a1 1 0 00.393.795z'
    />
  </svg>
)

export default SvgVolumeOutline
